<template>
  <svg class="icon" aria-hidden="true" v-if="colorful">
    <use :xlink:href="'#icon-' + type"></use>
  </svg>
  <i :class="['iconfont', 'icon-' + type]" v-else/>
</template>

<script>
import '@/assets/fonts/iconfont'

export default {
  props: {
    type: String,
    colorful: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import url("../assets/fonts/iconfont.css");

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
